import { ControlledCheckbox } from "@dune/ui";
import { useFormContext } from "react-hook-form";

type DeclarationCheckboxType = {
	label: string;
	name: string;
	show: boolean;
	subLabels?: string[];
};

interface DeclarationsContainerProps {
	isDisabled?: boolean;
}

const DeclarationsContainer = ({
	isDisabled = false,
}: DeclarationsContainerProps) => {
	const {
		control,
		watch,
		formState: { errors },
	} = useFormContext();

	const { actions } = watch();
	const commonPartsValue =
		actions?.types?.includes("SYNDIC") &&
		actions?.buildingType === "COMMON_PARTS";
	const privateWorkValue =
		actions?.types?.includes("SYNDIC") &&
		actions?.buildingType === "PRIVATE_WORK";
	const throughSyndicValue = watch("throughSyndic");

	const checkboxes: DeclarationCheckboxType[] = [
		{
			label:
				"L'opération de construction ne relève pas d'un contrat de construction de maison individuelle (CCMI)",
			name: "ccmi",
			show:
				actions?.types?.includes("CONSTRUCTION") &&
				actions?.buildingType === "INDIVIDUAL_HOUSE",
		},
		{
			label:
				"L'opération n'intègre pas l'utilisation de techniques de construction non courantes",
			name: "nonUsualMethods",
			show: true,
		},
		{
			label: "L'opération ne comprend pas l'une des activités suivantes :",
			name: "noOtherOperations",
			show: commonPartsValue || privateWorkValue || throughSyndicValue,
			subLabels: [
				"Opérations de désamiantage",
				"Création de sous-sol supplémentaire",
				"Reprise en sous oeuvre de fondations",
				"Surélévation des bâtiments existants",
				"Suppresion de façade ou d'un mur de pignon",
				"Création ou modification d'une piscine",
				"Pose ou intervention sur des panneaux solaires intégrés au bâti",
			],
		},
	];

	return (
		<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
			Je déclare que :
			<div className="flex flex-col gap-4">
				{checkboxes.map(
					(checkbox) =>
						checkbox.show && (
							<div className="flex flex-col" key={checkbox.name}>
								{checkbox.subLabels ? (
									<div className="flex flex-col">
										<ControlledCheckbox
											control={control}
											name={checkbox.name}
											id={checkbox.label}
											label={checkbox.label}
											error={errors[checkbox.name]?.message?.toString()}
											className="border-gray-300 disabled:bg-gray-100"
											disabled={isDisabled}
										/>
										<div className="pl-6">
											{checkbox.subLabels.map((subLabel) => (
												<p
													className={`italic ${isDisabled ? "text-gray-400" : ""}`}
													key={subLabel}
												>
													• {subLabel}
												</p>
											))}
										</div>
									</div>
								) : (
									<ControlledCheckbox
										control={control}
										name={checkbox.name}
										id={checkbox.label}
										label={checkbox.label}
										error={errors[checkbox.name]?.message?.toString()}
										className="border-gray-300 disabled:bg-gray-100"
										disabled={isDisabled}
									/>
								)}
							</div>
						),
				)}
			</div>
		</div>
	);
};

export default DeclarationsContainer;
